export default __webpack_public_path__ + "static/media/standard-quadruplo.e3ab2b16.jpg";